export default {
  obligations: [],
  isLoadingObligations: false,
  lookUpData: {
    chartNameOptions: [],
    usTaxTypeOptions: [],
    localTaxTypeOptions: [],
    currencyCodeOptions: [],
    connectionOptions: [],
    countryTaxTypes: [],
    filingGroupOptions: [],
  },
  userAssignedCompanyCodes: [],
  isLoadingUserAssignedCompanyCodes: false,
  isLoadingLookUpData: false,
  isLoadingObligationUpdate: false,
  isLoadingObligationCreate: false,
  uploadedObligations: [],
  isLoadingUploadedObligations: false,
  isLoadingObligationImport: false,
  isLoadingObligationRemove: false,
};
